import styled, { css } from 'styled-components';

export const SkillsAllocationTableRow = styled.div<{
  $isHeader?: boolean;
  $hasApplyColumn?: boolean;
}>`
  display: grid;
  grid-template-columns: ${({ $hasApplyColumn }) => ($hasApplyColumn ? '1fr 283px' : '1fr')};
  align-items: center;
  min-height: 72px;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.White};
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey5};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ theme }) => theme.typography.Body};

  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    grid-template-columns: ${({ $hasApplyColumn }) => ($hasApplyColumn ? '1fr 120px' : '1fr')};
  }

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.Grey1};
  }

  ${({ $isHeader, theme }) =>
    $isHeader &&
    css`
      min-height: 76px;
      padding: 24px 16px;
      border-bottom: 4px solid ${theme.colors.Grey4};
      ${theme.typography.Bold};
    `}
`;

export const ApplyToLocationCell = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AppliedLabel = styled.span`
  position: absolute;
  left: calc(50% + 20px);
  white-space: nowrap;
`;

export const EmptyStateMessage = styled.div`
  padding: 40px 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ theme }) => theme.typography.Body};
`;
